import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";

export default function PaymentForSubscriptionUnsuccessful({ notification }) {
  const [club, setClub] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const { user } = useAuthContext();
  const navi = useNavigate();
  //styed
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${notification.clubId}`
      );

      const profileReponse = await axios.get(
        `${ApiConnectionString}/api/BookingProfile/${notification.bookingProfileId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (profileReponse.status == 200) {
        setProfile(profileReponse.data);
      } else {
        setProfile(null);
      }

      if (clubResponse.status === 200) {
        setClub(clubResponse.data);
      } else {
        setClub(null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // You can set error state here if needed
    } finally {
      setIsLoading(false); // Stop loading state in any case
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    if (club && profile) {
      return (
        <div className="container bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2"> Failed Payment</p>
          </div>

          <p
            onClick={() => navi(`/myoneclub/${club.id}`)}
            className="fw-bold red-text pointer text-center"
          >
            {club.name}
          </p>
          <div
            onClick={() => navi(`/myoneclub/${club.id}`)}
            className="circle-crop mx-auto"
          >
            <img
              src={
                club.image
                  ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                  : NoImagePlaceholder
              }
              alt="Club Image"
              className="mt-0 pointer"
            />{" "}
          </div>
          <p>{notification.content}</p>
        </div>
      );
    } else {
      return (
        <div className="container bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2"> Failed Payment</p>
          </div>

          <p>The booking profile or club is no longer active.</p>
        </div>
      );
    }
  }
}
